import { useContext } from 'react'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import UserActivityPage from '.'
import { LoadingSpinner } from '../Loaders'

export default function UserActivityWebWrapper({ idType }) {
  const { setupData, setupLoading } = useContext(SetupContext)
  const { profileData } = useContext(ProfileContext)

  return setupLoading ? (
    <LoadingSpinner bgColor="#F5F5F599" dark />
  ) : (
    <UserActivityPage idType={idType} profileData={profileData} setupData={setupData} />
  )
}
